import React from 'react';
import { apsisEncrypt } from '../../helpers/apsisEncryption';
import fetchWrapper from '../../helpers/fetchWrapper';
import { Fragment, useEffect, useState } from 'react';
import { MultiSelect } from 'react-multi-select-component';
export const FormMultiSelect = ({
	value,
	onChange,
	getEvent,
	name,
	slug,
	dropdownOptions,
	placeholder,
	extra,
	...rest
}) => {
	const [options, setOptions] = useState([]);
	const [selected, setSelected] = useState([]);

	const handleChange = (select) => {
		// set state for this component
		setSelected(select);

		// send to parent component
		if (onChange) {
			onChange(select.map((item) => item.value));
		}

		if (getEvent) {
			const target = {
				name,
				value: select.map((item) => item.value),
				selectedItem: select,
				rules: { required: rest?.required },
			};

			getEvent({ target });
		}
	};

	const getOptionsField = async () => {
		await fetchWrapper
			.post('dropdown/dropdowndata', {
				dropdown_slug: slug,
				external_data: extra ? apsisEncrypt(extra) : '',
			})
			.then((response) => {
				const optionsItem = response.data ? response.data : [];
				setOptions(optionsItem);
			});
	};

	useEffect(() => {
		// set selected
		const selected = [];
		if (Array.isArray(value)) {
			options.forEach(function (item) {
				if (value?.includes(item.value)) selected.push(item);
			});
		} else if (typeof value === 'string') {
			const newValue = value.split(',').map((item) => (/^\d+$/.test(item) ? Number(item) : item));
			options.forEach(function (item) {
				if (newValue?.includes(item.value)) selected.push(item);
			});
		}
		setSelected(selected);
	}, [options, value]);

	useEffect(() => {
		if (slug && slug != '') {
			getOptionsField();
		} else if (dropdownOptions && dropdownOptions != '') {
			const optionItems = JSON.parse(dropdownOptions);
			setOptions(optionItems);
		}
		return () => {
			setSelected([]);
		};
	}, [extra, dropdownOptions]);

	return (
		<Fragment>
			<MultiSelect
				options={options}
				value={selected}
				onChange={handleChange}
				labelledBy={placeholder ?? 'Select'}
				overrideStrings={{
					selectSomeItems: placeholder??"Select...",
				}}
				{...rest}
			/>
		</Fragment>
	);
};

export default React.memo(FormMultiSelect);
